module.exports = {
    "className": "PointsBanner",
    classNameLabel: "Points Banner",
    "limit": 10,
    showExport: false,
    "columns": [
      {
        "columnName": "objectId",
            "type": "string"
      },
      {
        columnName: "image",
        columnLabel: "Image",
        type: "ParseFile",
      },
      {
        "columnName": "url",
        "type": "string",
        style: {
            whiteSpace: "normal",
            minWidth: "200px"
        }
      },
      {
        "columnName": "browser",
        "type": "string",
        style: {
            whiteSpace: "normal",
            minWidth: "120px"
        }
      },
      {
        "columnName": "deviceType",
        "columnLabel": "device",
        "type": "string",
        style: {
            whiteSpace: "normal",
            minWidth: "120px"
        }
      },
      {
        "columnName": "sort",
        "type": "number",
        style: {
            whiteSpace: "normal",
            minWidth: "130px"
        }
      },
      {
        columnName: "campaignStartDate",
        columnLabel: "CAMPAIGN START DATE",
        type: "Date",
        format: "MMM D, YYYY"
      },
      {
          columnName: "campaignEndDate",
          columnLabel: "CAMPAIGN END DATE",
          type: "Date",
          format: "MMM D, YYYY"
      },
      {
        "columnName": "createdAt",
            "type": "Date"
      },
      {
        "columnName": "updatedAt",
            "type": "Date"
      }
    ]
}  


// WEBPACK FOOTER //
// ./components/PointsBanner/PointsBanner.js